// @flow

import { pk, attr } from 'fc-decoders'

import {
  PROP_SOIL_JOB_ID,
  PROP_DATE,
  PROP_AREA,
  PROP_PRICE,
  PROP_CREATED_BY,
  PROP_COMPLETED_BY,
  PROP_ASSIGNED_TO,
  PROP_CREATED_DATE,
  PROP_COMPLETE,
  PROP_COMPLETED_DATE,
  PROP_SAMPLING_TYPE,
  PROP_STATUS,
  PROP_GRID_SIZE,
  PROP_ACTION,
  PROP_SUBFIELD,
  PROP_FIELD,
  PROP_FARM,
  PROP_GROWER,
  DATE_FORMAT,
} from 'hfty-model-soil-jobs'

export default {
  [PROP_SOIL_JOB_ID]: pk,
  [PROP_DATE]: attr('timestamp', {format: DATE_FORMAT}),
  [PROP_CREATED_DATE]: attr('timestamp', {format: DATE_FORMAT}),
  [PROP_COMPLETED_DATE]: attr('timestamp', {format: DATE_FORMAT}),
  [PROP_CREATED_BY]: attr('object'),
  [PROP_COMPLETED_BY]: attr('object'),
  [PROP_ASSIGNED_TO]: attr('object'),
  [PROP_FARM]: pk,
  [PROP_FIELD]: pk,
  [PROP_GROWER]: pk,
  [PROP_AREA]: attr('float', { precision: 15 }),
  [PROP_PRICE]: attr('float', { precision: 15 }),
  [PROP_STATUS]: attr('string'),
  [PROP_GRID_SIZE]: pk,
  [PROP_ACTION]: pk,
  [PROP_SUBFIELD]: pk,
  [PROP_SAMPLING_TYPE]: attr('string'),
  [PROP_COMPLETE]: attr('boolean'),
}
